import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import { NodeModelTypeEnum } from '@/comp/MapBuilder/nodes/enums';
import NodeWidget from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget';

import { BoosterNodeModel } from './BoosterNodeModel';
import { BoosterNodeWidget } from './BoosterNodeWidget';

export class BoosterNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.Booster);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new BoosterNodeModel();
  }

  generateReactWidget(event) {
    return (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        <BoosterNodeWidget
          engine={this.engine}
          node={event.model}
          entity={event.model.getEntity()}
          width={256}
          height={155}
          renderedOnMap
        />
      </NodeWidget>
    );
  }
}
